var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import Row from 'antd/lib/grid/row';
import Col from 'antd/lib/grid/col';
import 'antd/lib/grid/style/index.css';
import Page from 'src/pages/templates/Page';
import Scoreboard from 'src/imports/components/Scoreboard/components';
import ScrollerAthleteScoreRoute from 'src/imports/components/ScrollerAthleteScoreRoute';
import ListSponsors from './ListSponsors';
var selfStyles = require('./styles.scss');
var PageScoreboard = (function (_super) {
    __extends(PageScoreboard, _super);
    function PageScoreboard(props) {
        return _super.call(this, props) || this;
    }
    PageScoreboard.prototype.render = function () {
        var event = this.props.workspaceEvent.event;
        event.sponsors = typeof event.sponsors === 'string'
            ? JSON.parse(event.sponsors)
            : event.sponsors;
        return (React.createElement(Page, { documentTitle: "" + event.name, pageContentMaxWidth: '1280px' },
            event.sponsors.length > 0 &&
                React.createElement(Row, { gutter: 0 },
                    React.createElement(Col, { xs: { span: 24 }, md: { span: 12, push: 6 } },
                        React.createElement(Card, { className: selfStyles.cardSponsors },
                            React.createElement("div", { className: selfStyles.cardSponsorTitleWrapper },
                                React.createElement("h2", { className: selfStyles.cardSponsorTitle },
                                    "Event ",
                                    event.sponsors.length > 1 ? 'Sponsors' : 'Sponsor')),
                            React.createElement(ListSponsors, { sponsors: event.sponsors })))),
            React.createElement(Row, { gutter: 0 },
                React.createElement(Col, { xs: { span: 24 }, md: { span: 12, push: 6 } },
                    React.createElement(Card, { className: selfStyles.cardScoreboard },
                        React.createElement(Scoreboard, null)))),
            React.createElement(ScrollerAthleteScoreRoute, { style: { position: 'fixed', margin: '64px 0 0' } })));
    };
    return PageScoreboard;
}(React.Component));
var mapStateToProps = function (state) { return ({
    workspaceEvent: {
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
    },
}); };
export default connect(mapStateToProps)(PageScoreboard);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageScoreboard/index.tsx
// module id = 613
// module chunks = 0